module.exports = __webpack_public_path__ + "static/media/wifi-alert.68a190ea.svg";